import React, { useEffect, useState } from "react";
import { MerchantData } from "./merchants-data";
import { Image } from "react-bootstrap";
import "./merchant-slide.scss";
import { fetchApi } from "../../../../../service/services";


interface merchantsImg {
  id: number;
  acf: {
    merchant_image: string;

  };
}


export const Merchantslide = () => {
  const [merchants, setMerchants] = useState<merchantsImg[]>([]);
 

  useEffect(() => {
    fetchApi('merchants')
      .then((data) => {
        setMerchants(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  
  return (
    <section className="merchant-slide-section" id="merchants">
      <div className="d-flex Merchant-slide-container">
        <div
          className="merchant-slide-text"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="500"
          data-aos-once="false"
          data-aos-anchor-placement="down-center"
        >
          <p className=" fw-bold text-break text-start ">5000+</p>
          <p className="text-break fs-6 fw-light">Merchants trust Pamo</p>
        </div>
        <div className="d-flex flex-nowarap overflow-auto merchant-slide mx-5">
          {merchants.map((data, key) => (
            <div
              key={data?.id}
              className="merchant-slide-card mx-3 rounded-circle"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-once="false"
              data-aos-anchor-placement="down-center"
            >
              <Image src={data?.acf?.merchant_image} className="slide-image rounded-circle" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
